{
  "sdk-download-android": "Descargar para Android",
  "sdk-connect": "Conecta",
  "sdk-download-ios": "Descargar para iOS",
  "sdk-install": "Instala",
  "sdk-modal-instruct-1": "1. Abre la aplicación de Binance",
  "sdk-modal-instruct-2": "2. Toca {{icon}} en la pantalla de inicio",
  "sdk-modal-title": "Conectar con Binance",
  "sdk-no-app": "¿Aún no tienes la aplicación de Binance?"
}